import axios from "api/axiosInstance";
import { AIReviewEvaluationGroup, AIReviewEvaluation } from "common/models/types";

interface ApiResponse<T> {
  error: number;
  data: T;
}

interface EvaluationGroupListParams {
  testGroupKey?: string;
  evaluationGroupKey?: string;
  experimentId?: number;
  scrapped?: boolean;
  hidden?: boolean;
  search?: string;
  startDate?: string;
  endDate?: string;
  limit?: number;
  offset?: number;
}

export const evaluationGroupApi = {
  // 평가 그룹 목록 조회
  findAll: (params?: EvaluationGroupListParams) =>
    axios.get<ApiResponse<AIReviewEvaluationGroup[]>>("/api/v1/admin/ai-review-evaluation/evaluation-groups", {
      params,
    }),

  // 평가 그룹 상세 조회
  findOne: (id: number) =>
    axios.get<ApiResponse<AIReviewEvaluationGroup>>(`/api/v1/admin/ai-review-evaluation/evaluation-groups/${id}`),

  // 평가 그룹의 평가 목록 조회 (올바른 엔드포인트 사용)
  findEvaluations: (groupId: number, params?: { limit?: number; offset?: number; withPatientId?: boolean }) =>
    axios.get<ApiResponse<AIReviewEvaluation[]>>(`/api/v1/admin/ai-review-evaluation/evaluations`, {
      params: {
        evaluationGroupId: groupId,
        limit: params?.limit || 100,
        withPatientId: true, // Patient ID 항상 포함
        ...params,
      },
    }),

  // 평가 그룹 숨김 토글
  toggleHide: (id: number) =>
    axios.put<ApiResponse<AIReviewEvaluationGroup>>(`/api/v1/admin/ai-review-evaluation/evaluation-groups/${id}/hide`),

  // 평가 그룹 스크랩 토글
  toggleScrap: (id: number) =>
    axios.put<ApiResponse<AIReviewEvaluationGroup>>(`/api/v1/admin/ai-review-evaluation/evaluation-groups/${id}/scrap`),

  // 평가 그룹 플래그 업데이트
  updateFlags: (id: number, flags: { scrapped?: boolean; hidden?: boolean }) =>
    axios.put<ApiResponse<AIReviewEvaluationGroup>>(`/api/v1/admin/ai-review-evaluation/evaluation-groups/${id}/flags`, flags),

  // 평가 그룹 통계 재계산
  recalculateStats: (id: number) =>
    axios.post<ApiResponse<AIReviewEvaluationGroup>>(`/api/v1/admin/ai-review-evaluation/evaluation-groups/${id}/recalculate-stats`),
};